import { render, staticRenderFns } from "./ModalTable.vue?vue&type=template&id=2732b25a&scoped=true"
import script from "./ModalTable.vue?vue&type=script&lang=js"
export * from "./ModalTable.vue?vue&type=script&lang=js"
import style0 from "pretty-checkbox/dist/pretty-checkbox.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ModalTable.vue?vue&type=style&index=1&id=2732b25a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2732b25a",
  null
  
)

export default component.exports